import React from 'react';
import { siteConfig } from '../config/siteConfig';
import { motion } from 'framer-motion';
export function StatsSection() {
  return <section className="w-full bg-brand-navy py-24 md:py-40 text-white relative overflow-hidden" data-id="element-228">
      {/* Noise Texture */}
      <div className="absolute inset-0 bg-noise opacity-[0.03] pointer-events-none mix-blend-overlay" data-id="element-229"></div>

      <div className="container mx-auto px-4 max-w-7xl relative z-10" data-id="element-230">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-231">
          <span className="text-brand-gold font-bold tracking-widest text-sm uppercase mb-4 block" data-id="element-232">
            {siteConfig.stats.eyebrow}
          </span>
          <h2 className="font-heading text-3xl md:text-[48px] font-bold mb-6 leading-tight" data-id="element-233">
            {siteConfig.stats.headline}
          </h2>
          <p className="text-lg md:text-xl text-gray-300 font-light" data-id="element-234">
            {siteConfig.stats.subtext}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-235">
          {siteConfig.stats.cards.map((card, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="relative group rounded-3xl p-[1px] overflow-hidden bg-gradient-to-b from-brand-gold/40 to-white/5 hover:from-brand-gold hover:to-brand-gold/30 transition-all duration-500" data-id="element-236">
              <div className="absolute inset-0 bg-brand-gold/0 group-hover:bg-brand-gold/10 transition-colors duration-500 blur-xl" data-id="element-237"></div>
              <div className="bg-brand-navy h-full w-full rounded-[23px] p-10 text-center relative z-10 flex flex-col justify-center items-center" data-id="element-238">
                <div className="text-6xl md:text-[80px] font-serif font-medium text-brand-gold mb-6 leading-none" data-id="element-239">
                  {card.stat}
                </div>
                <p className="text-sm md:text-base text-gray-300 leading-relaxed font-light" data-id="element-240">
                  {card.label}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}